import React from 'react';
import SlBadge from '@shoelace-style/shoelace/dist/react/badge';
import { HiOutlineBell } from 'react-icons/hi';
import { GLOBAL_COLORS } from '@iblai/ibl-web-react-common';
import './NotitificationBoxContainer.css';

const NotificationBoxContainer = ({ onClick, notificationCount = 0 }) => {
  return (
    <div className='ibl-custom-notification-box-container' onClick={onClick}>
        <HiOutlineBell
          style={{ width: '22px', height: '22px' }}
          color={GLOBAL_COLORS.primary}
          className={'image-3 notification-trigger'}
        />
        {notificationCount > 0 && (
          <SlBadge className='ibl-custom-notification-badge' variant="danger" pill>
            {notificationCount}
          </SlBadge>
        )}
    </div>
  );
};

export default NotificationBoxContainer;
